import {Skeleton, Stack, Typography} from "@mui/material";
import React from "react";

import randomN from "../../../utils/randomN";

function ContentItemTitlePlaceholder() {
	return (
		<Stack>
			<Skeleton width={`${randomN(10, 60)}ch`} sx={{maxWidth: "100%"}}>
				<Typography variant="inherit" component="span">
					.
				</Typography>
			</Skeleton>
			<Skeleton width="10ch" sx={{maxWidth: "100%"}}>
				<Typography variant="inherit" component="span">
					.
				</Typography>
			</Skeleton>
		</Stack>
	);
}

export default ContentItemTitlePlaceholder;
